import React, { useEffect, useState, useContext } from 'react';
import PageLink from 'components/PageLink/PageLink';
import styles from './CustomerNotAuthorized.module.scss';
import { IsCallCenterWorkingTime } from 'common/helpers/Callus';
import { useAppSelector } from 'app/hooks';
import { selectCurrentMarket } from 'features/core/selectors';
import { Permissions } from 'common/consts/customerPermissions';
import { Market } from 'common/consts/markets';
import { useMediaQuery } from 'react-responsive';
import RESPONSIVE from 'common/consts/responsive';
import TagManager from 'react-gtm-module';
import CallUsNowButton from 'components/CallUsNowButton/CallUsNowButton';
import CallBackButton from 'components/CallBackButton/CallBackButton';
interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
  onClose: () => void;
}

const CustomerNotAuthorized = ({
  PageData,
  Model,
  LayoutModel,
  onClose,
}: Props) => {
  const currentMarket = useAppSelector(selectCurrentMarket);
  const [callusText, setCallusText] = useState<string>(
    PageData?.CallUsNowButtonText,
  );
  const [callusNumber, setCallusNumber] = useState<string>('');

  const showCallUsNowButton = !LayoutModel?.DisableWebDeflect && IsCallCenterWorkingTime(
    LayoutModel?.CallCenterDaysHours,
    LayoutModel?.CallCenterHolidays,
  );

  const isMobileSize = useMediaQuery({ maxWidth: 767 });
  const handleCallUsNowClick = () => {
    let countryPhoneNumber = LayoutModel.CallCenterPhoneNumber;
    setCallusText(countryPhoneNumber || '');
    setCallusNumber(countryPhoneNumber);
  };

  const handleSendUsMessageClick = () => {
    window.location = Model?.ContactFormUrl;
  };

  return (
    <div className="modal-overlay is-active">
      <div className="modal-dialog">
        <div className="modal-content">
          <a onClick={() => onClose()} className="modal-close"></a>
          <div className="modal-header">
            {' '}
            {PageData.CustomerNotAuthorizedHeading}
          </div>
          <div className="modal-body u-center">
            <p className="modal-para">
              {PageData.CustomerNotAuthorizedContent}
            </p>
            <div>
              <div>
                {(LayoutModel?.EnableCallBackForm && showCallUsNowButton == false && LayoutModel?.DisableWebDeflect == false) ? (
                  <>
                    <CallBackButton
                      buttonUrl={Model?.RequestCallBackPageUrl}
                      buttonText={PageData?.RequestCallBackButtonText}
                      classNames={'Button u-block u-marginBxxsm w-100'}
                    />
                    <button
                      type="button"
                      className="Button u-block Button--ghost black-border u-marginBxxsm w-100"
                      onClick={() => {
                        onClose();
                      }}
                    >
                      <span>{PageData?.TryAgainButtonText}</span>
                    </button>
                    <button
                      type="button"
                      className="Button u-block Button--ghost black-border u-marginBxxsm w-100"
                      onClick={handleSendUsMessageClick}
                    >
                      <span>{PageData?.SendMessageButtonText}</span>
                    </button>
                  </>
                ) :
                  (
                    <>
                      {showCallUsNowButton && (
                        <CallUsNowButton
                          callusNumber={callusNumber}
                          callusText={callusText}
                          isMobileSize={isMobileSize}
                          onCallUsNowClick={handleCallUsNowClick}
                          classNames={'Button u-block u-marginBxxsm w-100'}
                        />
                      )}
                      <button
                        type="button"
                        className="Button u-block u-marginBxxsm w-100"
                        onClick={() => {
                          onClose();
                        }}
                      >
                        <span>{PageData?.TryAgainButtonText}</span>
                      </button>

                      <button
                        type="button"
                        className="Button u-block Button--ghost black-border u-marginBxxsm w-100"
                        onClick={handleSendUsMessageClick}
                      >
                        <span>{PageData?.SendMessageButtonText}</span>
                      </button>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default CustomerNotAuthorized;
